import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonSearchbar, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import * as Leaflet from 'leaflet';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { buscarEndereco, requestService } from '../../../../../Utils/Services';
import { useGooglePlacesSimple } from '../../../../../components/useGooglePlacesSimple';
import './Endereco.css';

type Props = {
  endereco: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
}

const Endereco: React.FC<Props> = (props: Props) => {

  const history = useHistory();
  const location = useLocation<any>();

  const [enderecoSelecionado, setEnderecoSelecionado] = useState<any>();

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [latitudeSelecionado, setLatitudeSelecionado] = useState('');
  const [longitudeSelecionado, setLongitudeSelecionado] = useState('');

  let mapa: any = null;
  let mark: any = null;
  // let circle: any = null;
  const [mapState, setMapState] = useState<any>(null);
  const [markState, setMarkState] = useState<any>(null);
  // const [circleState, setCircleState] = useState<any>(null);
  const [localizacaoState, setLocalizacaoState] = useState<any>(null);

  const [localEnderecoSelecionado, setLocalEnderecoSelecionado] = useState<any>("");
  const [listaEnderecos, setListaEnderecos] = useState<any>([]);

  // Hook Google Places Simple para busca de endereços
  const {
    listaEnderecos: listaEnderecosGoogle,
    buscandoEndereco,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEnderecoHook,
    limparSugestoes
  } = useGooglePlacesSimple({
    onError: (mensagem) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading,
    debounceTime: 2000,
    minChars: 4
  });

  // Flag para evitar busca automática quando preenchemos programaticamente
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  const myIcon = new Leaflet.Icon({
    iconUrl: '/assets/pin.svg',
    iconSize: [30, 30],
    popupAnchor: [0, -20]
  });

  useEffect(() => {
    // Define o foco no input quando o componente é montado
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);


  // useEffect(() => {

  //   if (props.endereco != "") {
  //     setEnderecoSelecionado(props.endereco);
  //     console.log("entrou no useEffect");
  //   }
  // }, [props.endereco]);

  useEffect(() => {
    const timer = setTimeout(() => {
      loadMap();
    }, 500); // Atraso de 1000ms

    return () => clearTimeout(timer); // Limpeza do timer
  }, []);

  useIonViewDidEnter(() => {

  })

  function cadastrar() {

    if (localizacaoState == null || !enderecoSelecionado || !latitudeSelecionado || !longitudeSelecionado) {
      setTextToast('Selecione um local para continuar.');
      setShowToast(true);
    }
    else {
      props.closeAction(enderecoSelecionado, latitudeSelecionado, longitudeSelecionado);
    }


  }

  function loadMap() {
    try {
      mapa = Leaflet.map('map').fitWorld();

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '© OpenStreetMap'
      }).addTo(mapa);

      mapa.on('locationfound', onLocationFound);

      mapa.on('locationerror', onLocationError);

      mapa.on('click', (ev: any) => {
        //mark.setLatLng(ev.latlng);
        //circle.setLatLng(ev.latlng);                
      });

      setMapState(mapa);

      mapa.locate({ setView: true, maxZoom: 17 });
    }
    catch (e: any) {
      console.log("deu erro" + e.message);
    }
  }

  async function onLocationFound(e: any) {
    console.log("encontrou a localizacao", e.latlng);
    //let radius = 100;

    setLocalizacaoState(e.latlng);

    mark = Leaflet.marker(e.latlng, { icon: myIcon, draggable: true }).addTo(mapa);
    setMarkState(mark);



    // if (props.endereco) {
    //   let response = await buscarLocalizacaoPromise(props.endereco).catch((error) => {
    //     console.log("error.message", error.message);
    //     setTextToast(error.message);
    //     setShowToast(true);

    //   });

    //   if (response && response.Items) {

    //     console.log("response.Items", response.Items);

    //     setLatitudeSelecionado(e.latlng.lat);
    //     setLongitudeSelecionado(e.latlng.lng);
    //     setLocalizacaoState(e.latlng);

    //     mark = Leaflet.marker(e.latlng, { icon: myIcon, draggable: true }).addTo(mapa);
    //     setMarkState(mark);

    //   }
    // }

    mark.on("dragend", () => {
      //circle.setLatLng(mark.getLatLng());
      //console.log("markMatriz", mark.getLatLng());
      //setLocalizacaoState(mark.getLatLng());
    })

    mark.on("move", () => {
      const latlng = mark.getLatLng();
      setLocalizacaoState(latlng);
      setLatitudeSelecionado(latlng.lat);
      setLongitudeSelecionado(latlng.lng);
      //console.log("markMatriz", mark.getLatLng());
    })

    // circle = Leaflet.circle(e.latlng, radius).addTo(mapa);
    // setCircleState(circle);





    // **************** retirado bloco de excluir
    // markExcluir = Leaflet.marker(e.latlng, { icon: myIconExcluir, draggable: true }).addTo(mapa);
    // setMarkExcluirState(markExcluir);

    // markExcluir.on("dragend", () => {
    //     circleExcluir.setLatLng(markExcluir.getLatLng());
    //     //console.log("markExcluir", markExcluir.getLatLng());
    //     //setLocalizacaoState(mark.getLatLng());
    // })

    // markExcluir.on("move", () => {
    //     setLocalizacaoExcluirState(markExcluir.getLatLng());
    //     //console.log("markExcluir", markExcluir.getLatLng());
    // })

    // circleExcluir = Leaflet.circle(e.latlng, radius).addTo(mapa);
    // setCircleExcluirState(circleExcluir);






  }

  function onLocationError(e: any) {
  }

  // Função para buscar detalhes do endereço selecionado
  const buscarDetalhesEndereco = async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEnderecoHook(placeId, enderecoFormatado);

      // Preencher campos automaticamente
      setIgnorarProximaMudanca(true);
      setEnderecoSelecionado(detalhes.endereco);
      setLatitudeSelecionado(detalhes.latitude.toString());
      setLongitudeSelecionado(detalhes.longitude.toString());

      // Atualizar mapa
      if (markState && mapState) {
        let novaLocalizacao = Leaflet.latLng(Number(detalhes.latitude), Number(detalhes.longitude));
        markState.setLatLng(novaLocalizacao);
        mapState.setView(novaLocalizacao, 14);
        setLocalizacaoState(novaLocalizacao);
      }

      // Limpar sugestões
      limparSugestoes();

      // setTextToast("Endereço validado com sucesso.");
      // setShowToast(true);

    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
    }
  };

  // Handler para seleção de item da lista de sugestões (novo formato Google)
  const handleSelectItemGoogle = (item: any) => {
    console.log("Item Google selecionado:", item);
    buscarDetalhesEndereco(item.placeId, item.descricao);
  };

  function buscarLocalizacao(endereco: any) {
    if (endereco.replace(/\s/g, "") == "") return;

    let enderecoTratado = endereco.toLowerCase().replace(/\s/g, "+");

    setShowLoading(true);
    requestService(buscarEndereco.url.replace("{id}", enderecoTratado), {

      method: buscarEndereco.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.Item) {
          try {
            setLatitudeSelecionado(response.Item.enderecoLat);
            setLongitudeSelecionado(response.Item.enderecoLng);

            let novaLocalizacao = Leaflet.latLng(Number(response.Item.enderecoLat), Number(response.Item.enderecoLng));
            markState.setLatLng(novaLocalizacao);
            //circleState.setLatLng(novaLocalizacao);
            mapState.setView(novaLocalizacao, 14);
            setLocalizacaoState(novaLocalizacao);

            // setTextToast("Endereço validado com sucesso.");
            // setShowToast(true);
          } catch (error) {
            console.log("error", error);
          }

        }
      },
      (error: any) => {
        console.log("e1", error);
        setTextToast(error.message);
        setShowToast(true);
        if (error.data) {
          console.log("entrou varios endereços");
          if (Array.isArray(error.data) && error.data.length > 0) {
            setListaEnderecos(error.data);
          }
        }
      }).finally(() => { setShowLoading(false); });

  }



  async function buscarLocalizacaoPromise(endereco: any): Promise<any> {


    return new Promise((resolve, reject) => {

      if (endereco.replace(/\s/g, "") == "") return;

      let enderecoTratado = endereco.toLowerCase().replace(/\s/g, "+");

      setShowLoading(true);

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      let montarUrl = buscarEndereco.url;



      requestService(montarUrl.replace("{id}", enderecoTratado), {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          resolve(response); // Resolvendo a promessa com a resposta
        },
        (error: any) => {
          reject(error); // Rejeitando a promessa com o erro
        });
    });
  }

  const handleSelectItem = (item: any) => {
    setListaEnderecos([]);

    console.log("item", item);

    // setEnderecoSelecionado(item.formatted_address);
    setLatitudeSelecionado(item.geometry.location.lat);
    setLongitudeSelecionado(item.geometry.location.lng);

    let novaLocalizacao = Leaflet.latLng(Number(item.geometry.location.lat), Number(item.geometry.location.lng));
    markState.setLatLng(novaLocalizacao);
    //circleState.setLatLng(novaLocalizacao);
    mapState.setView(novaLocalizacao, 14);
    setLocalizacaoState(novaLocalizacao);
  };


  return (
    <>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Endereço</IonTitle>

        </IonToolbar>
        <div style={{ background: "var(--ion-color-primary)", padding: "0px", margin: "0px" }}>
          <IonSearchbar
            ref={(ref) => props.inputRef.current = ref}
            value={enderecoSelecionado}
            onIonChange={(e) => {
              const valor = e.detail.value || "";
              setEnderecoSelecionado(valor);
              setListaEnderecos([]);

              // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
              if (ignorarProximaMudanca) {
                setIgnorarProximaMudanca(false);
                return;
              }

              // Buscar sugestões automaticamente usando Google Places
              buscarSugestoesEndereco(valor);
            }}
            enterkeyhint="search"
            onKeyDown={(e: any) => {
              // Enter força busca imediata
              if (e.key === "Enter") {
                e.preventDefault();
                const valor = enderecoSelecionado || '';
                if (valor.trim().length >= 4) {
                  buscarSugestoesEndereco(valor, true);
                } else {
                  setTextToast('Digite no mínimo 4 caracteres para buscar.');
                  setShowToast(true);
                }
              }
            }}
            placeholder="Avenida Paulista, 111, São Paulo"
          ></IonSearchbar>
        </div>
        {/* Lista de sugestões do Google Places */}
        {listaEnderecosGoogle?.length > 0 && (
          <IonList style={{ position: 'absolute', zIndex: 999, backgroundColor: 'white', width: '100%', height: "auto", borderBottom: '1px solid #f1f1f1' }}>
            {listaEnderecosGoogle.map((item: any, index: any) => (
              <IonItem lines="none" key={"google" + index} button onClick={() => handleSelectItemGoogle(item)}>
                <IonLabel>
                  <strong>{item.descricaoPrincipal}</strong>
                  {item.descricaoSecundaria && <div style={{ fontSize: '0.9em', color: '#666' }}>{item.descricaoSecundaria}</div>}
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}
        {/* Lista antiga (fallback) */}
        {listaEnderecos?.length > 0 && (
          <IonList style={{ position: 'absolute', zIndex: 999, backgroundColor: 'white', width: '100%', height: "auto", borderBottom: listaEnderecos.length > 0 ? '1px solid #f1f1f1' : 'none' }}>
            {listaEnderecos.map((item: any, index: any) => (
              <IonItem lines="none" key={"filtro" + index} button onClick={() => handleSelectItem(item)}>
                <IonLabel>{item.formatted_address}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}

      </IonHeader>
      <IonContent className={"Mapa"}>

        {/* <div style={{ pointerEvents: "none", position: "fixed", top: 0, left: 0, width: "100%", height: "105%" }}>
          <Iframe key={"0"}
            url={"https://www.google.com/maps/embed/v1/view?key=AIzaSyDsbVscwNhxsgMynsga97Rea933LJLG5Jw&center=" + latitudeSelecionado + "," + longitudeSelecionado + "&zoom=15&maptype=roadmap"}
            width="100%"
            height="100%"
            id="myId"
            className="myClassname"
            display="inline"
            position="absolute"
            frameBorder={0}
            styles={{ border: "0" }}
          />
        </div>
        <div id="carrinho" style={{ position: "relative", width: "100%", height: "105%"}}>
          <img width={60} height={60} style={{ margin: "auto" }} src={"/assets/pin.svg"}></img>
        </div> */}
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div id="map" style={{ width: "100%", height: "100%" }}></div>
        </div>

        {/* <div id="map"></div> */}
      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={() => cadastrar()} expand="block" type="submit">Selecionar</IonButton>
        </IonToolbar>
      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ endereco, inputRef, closeAction, closeActionSimple }: { endereco: any, inputRef: any, closeAction: Function, closeActionSimple: Function }) => (
  <Endereco endereco={endereco} inputRef={inputRef} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </Endereco>
)
